import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/charterExtraServices', request)
}

async function post(request) {
    return await postMethod('/api/charterExtraServices', request)
}

async function put(request) {
    return await putMethod('/api/charterExtraServices', request)
}

export {get, post, put}
